import { UserRank, UserRankType } from "@garther/interfaces";
import { cn } from "@garther/ui/libs";

const RANK_CONFIG: Record<UserRankType, { label: string; className: string }> = {
  [UserRank.NONE]: {
    label: "Normal",
    className: "bg-gray-100 text-gray-500 border-gray-200"
  },
  [UserRank.BRONZE]: {
    label: "Bronze",
    className: "bg-amber-100 text-amber-800 border-yellow-300"
  },
  [UserRank.SILVER]: {
    label: "Silver",
    className: "bg-slate-100 text-slate-600 border-slate-300"
  },
  [UserRank.GOLD]: {
    label: "Gold",
    className: "bg-yellow-50 text-yellow-700 border-yellow-300"
  },
  [UserRank.PLATINUM]: {
    label: "Platinum",
    className: "bg-cyan-50 text-cyan-700 border-cyan-200"
  }
};

interface RankBadgeProps {
  rank: UserRankType;
  showLabel?: boolean;
  className?: string;
}

export function RankBadge({ rank, showLabel = true, className }: RankBadgeProps) {
  const config = RANK_CONFIG[rank];

  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full border font-semibold tracking-[0.1em] uppercase",
        showLabel ? "gap-1.5 px-2.5 py-1 text-xs" : "p-1.5",
        config.className,
        className
      )}
    >
      <span className={cn("rounded-full bg-current flex-none", showLabel ? "w-1.5 h-1.5" : "w-2 h-2")} />
      {showLabel && config.label}
    </span>
  );
}
